// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DrilldownBreadcrumb.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import classnames from 'classnames';
import ReportPartUtils from 'share/utils/Izenda.ReportPartUtils';
import HighchartUtils from 'share/components/charting/highcharts/Izenda.HighchartUtils';
import ChartDataParser from 'share/utils/Izenda.ChartDataParser';
import { NULL_VALUE, BLANK_VALUE } from 'logic/data/Izenda.UIConstants';
import connect from 'share/enhancers/Izenda.Connect';
import { get, isFunction, size, isNil } from 'lodash/fp';

const SEPARATOR_SIGN = '|';

export default connect()(function DrilldownBreadcrumb(props: any) {
  const reportPartContent = props.reportPartContent || get('reportPart.reportPartContent', props);
  // do not show drill down
  if (!reportPartContent || !reportPartContent.hasDrillDown) {
    return null;
  }

  const onClickBreadcrumb = (point: any) => {
    isFunction(props.onDrillDown) && props.onDrillDown(point, null);
  };

  const getValue = (point: any) => {

    const columnName = get('field.columnName', point);
    const record = get('record', point);
    const fieldValues = ReportPartUtils.getFieldValue(columnName, record);
    const reportPartElm = get('field.reportPartElm', point);
    const fieldDataType = get('field.reportPartElm.fieldDataType', point);

    const stringFormatValue = HighchartUtils.getFormatedValueByStringFormat(
      reportPartElm, fieldValues.value, fieldDataType
    );
    if (!isNil(stringFormatValue)) {
      fieldValues.value = stringFormatValue;
    }


    return ReportPartUtils.getDataFormat(
      fieldValues,
      ChartDataParser.getSerieProppertiesByField(get('field.reportPartElm', point)),
      {
        record: point.record,
        element: point.field
      }
    );
  };

  const getPointValue = (point: any) => {
    const value = getValue(point);
    switch (value) {
      case null:
        return NULL_VALUE;
      case '':
        return BLANK_VALUE;
      default:
        return value;
    }
  };

  const { localization } = props;
  const renderTopLevel = (levelSize: number) => {
    var TOP_LEVEL = localization.getText('COMMON_LABEL_ALL');
    if (levelSize === 0) {
      return <span title={TOP_LEVEL}>{TOP_LEVEL}</span>;
    }
    return (
      <a title={TOP_LEVEL} onClick={onClickBreadcrumb.bind(this, null)}>
        {TOP_LEVEL}
      </a>
    );
  };

  const points = props.points || (props.getPoints && props.getPoints());
  const classes = classnames('izenda-ReportPartChart-Breadcrumb overflow-text', props.className);
  return (
    <div className={classes}>
      {/* top level */}
      {!props.hideAllLevel && renderTopLevel(size(points))}
      {points.map((point: any, index: number) => {
        const pointValue = getPointValue(point);
        const itemKey = index + pointValue;
        const showSeparator = !(props.hideAllLevel && index === 0);

        if (index === points.length - 1) {
          return (
            <span key={itemKey} title={pointValue}>
              {showSeparator && SEPARATOR_SIGN} {pointValue}
            </span>
          );
        }
        return (
          <a key={itemKey} title={pointValue} onClick={onClickBreadcrumb.bind(this, point)}>
            {showSeparator && SEPARATOR_SIGN} {pointValue}
          </a>
        );
      })}
    </div>
  );
});



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/Izenda.DrilldownBreadcrumb.js